import fromPairs from 'lodash/fromPairs';
import omit from 'lodash/omit';
import { createUserAgreement, deleteUserAgreement, reorderAgreements, updateUserAgreement } from '../api';
import { objectsDiff } from '../lib/utils';

export type UserAgreementDraft = {
    name: string;
    url: string;
    order: number;
};

export type UserAgreement = UserAgreementDraft & {
    id: string;
};

export type UserAgreementOrDraft = UserAgreement | UserAgreementDraft;

export const formUARequests = async (skillId: string, fetched: UserAgreement[], drafts: UserAgreementOrDraft[]) => {
    const fetchMap = new Map(fetched.map((item) => [item.id, item]));
    const orderedIds: string[] = [];
    for (const draft of drafts) {
        const unordered = omit(draft, 'order');
        if ('id' in unordered && typeof unordered['id'] === 'string') {
            if (objectsDiff(fetchMap.get(unordered.id), unordered).length > 0) {
                await updateUserAgreement(unordered, skillId);
                orderedIds.push(unordered.id);
            }
            fetchMap.delete(unordered.id);
        } else {
            const { id } = await createUserAgreement(unordered, skillId);
            orderedIds.push(id);
        }
    }
    for (const item of fetchMap.values()) {
        await deleteUserAgreement(item, skillId);
    }
    if (orderedIds.length) {
        const reordered = fromPairs(orderedIds.map((id, idx) => [id, idx]));
        await reorderAgreements(skillId, reordered);
    }
};
